/**
 *  @class
 *  @function CartDiscounts
 */
if (!customElements.get('cart-discounts')) {
  class CartDiscounts extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {

      this.discounts();
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      }, {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      const element = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
      return element ? element.innerHTML : '';
    }
    enqueueCartMutation(operation) {
      const previous = window.__idgCartMutationQueue || Promise.resolve();
      const current = previous.catch(() => undefined).then(operation);
      window.__idgCartMutationQueue = current.catch(() => undefined);
      return current;
    }
    discounts() {
      const button = this.querySelector('.cart-discounts--button');
      const remove_discount_buttons = this.querySelectorAll('.cart-discounts--remove');

      remove_discount_buttons.forEach((remove_discount_button) => {
        remove_discount_button.addEventListener('click', this.removeDiscount.bind(this));
      });
      if (!button) return;

      button.addEventListener('click', async (event) => {
        event.preventDefault();
        if (button.classList.contains('loading')) return;
        button.classList.add('loading');
        button.disabled = true;
        try {
          await this.enqueueCartMutation(() => this.updateDiscount());
        } catch (error) {
          console.error(error);
          this.showError();
        } finally {
          button.classList.remove('loading');
          button.disabled = false;
        }
      });
    }
    async updateDiscount() {
      const discountCode = this.querySelector('.cart-discounts--input');
      const discountCodeValue = discountCode?.value.trim();
      if (!discountCodeValue) return;
      const existingDiscounts = this.existingDiscounts();

      if (existingDiscounts.some((code) => code.toLowerCase() === discountCodeValue.toLowerCase())) return;
      existingDiscounts.push(discountCodeValue);

      return this.renderDiscounts(existingDiscounts, discountCodeValue);
    }
    async removeDiscount(event) {
      event.preventDefault();
      const button = event.currentTarget;
      if (button.classList.contains('loading')) return;
      const pill = button.parentElement?.querySelector('.cart-discounts--name');
      const discountCode = pill?.textContent.trim();
      if (!discountCode) return;
      const existingDiscounts = this.existingDiscounts();
      const index = existingDiscounts.findIndex((code) => code.toLowerCase() === discountCode.toLowerCase());
      if (index === -1) return;

      existingDiscounts.splice(index, 1);
      button.classList.add('loading');
      button.disabled = true;
      try {
        await this.enqueueCartMutation(() => this.renderDiscounts(existingDiscounts));
      } catch (error) {
        console.error(error);
        this.showError();
        button.classList.remove('loading');
        button.disabled = false;
      }
    }
    existingDiscounts() {
      const discountCodes = [];
      const discountPills = this.querySelectorAll('.cart-discounts--name');
      for (const pill of discountPills) {
        const code = pill.textContent.trim();
        if (code && !discountCodes.some((existing) => existing.toLowerCase() === code.toLowerCase())) {
          discountCodes.push(code);
        }
      }

      return discountCodes;
    }
    showError() {
      document.querySelectorAll('.cart-discounts--error').forEach((el) => {
        el.removeAttribute('hidden');
      });
    }
    async renderDiscounts(existingDiscounts, discountCodeValue) {
      const body = JSON.stringify({
        discount: existingDiscounts.join(','),
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      this.querySelector('.cart-discounts--error')?.setAttribute('hidden', '');
      const response = await fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      });
      if (!response.ok) throw new Error(`Discount update failed (${response.status})`);
      const parsedState = await response.json();

      const wasDiscountOpen = !!this.closest('details[open]');

      this.getSectionsToRender().forEach((section => {
        const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

        if (parsedState.sections?.[section.section] && elementToReplace) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }
      }));

      if (wasDiscountOpen) {
        document.querySelectorAll('.cart-discounts--title').forEach((el) => {
          el.closest('details')?.setAttribute('open', '');
        });
      }
      if (discountCodeValue) {
        const appliedCode = Array.isArray(parsedState.discount_codes) && parsedState.discount_codes.find((discount) => {
          return discount.code?.toLowerCase() === discountCodeValue.toLowerCase();
        });
        if (!appliedCode || appliedCode.applicable !== true) {
          setTimeout(() => this.showError(), 300);
        }
      }
      return parsedState;
    }
  }
  customElements.define('cart-discounts', CartDiscounts);
}
